<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    class="charts-dialog"
    width="1240px"
    @close="handleClose"
  >
    <div class="df aic jcc" style="margin-bottom: 20px">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        value-format="yyyy-MM-dd"
        @change="onSearch"
      ></el-date-picker>
      <el-button
        style="margin-left: 10px; height: 40px"
        type="success"
        size="small"
        @click="changeShowCharts"
      >
        {{ showCharts ? "切换表格" : "切换图表" }}
      </el-button>
      <el-button
        style="margin-left: 10px; height: 40px"
        type="warning"
        size="small"
        v-if="checkedHisListId"
        @click="
          hisQuery.page = 1;
          checkedHisListId = null;
        "
      >
        全部数据
      </el-button>
    </div>
    <template v-if="showCharts">
      <div class="df aic jcc">
        <div style="flex: 0 0 800px; width: 0px; background-color: #fff">
          <SensorCharts
            v-if="dialogVisible && !checkedHisListId"
            :initialData="gridData"
            :chart-height="800"
            @load-more="handleLoadMore"
            :unit="unit"
            :page="hisQuery.page"
            :limit="hisQuery.limit"
          />
          <SensorCharts
            v-if="dialogVisible && checkedHisListId"
            :initialData="hisListDetail"
            :chart-height="800"
            @load-more="handleLoadMore"
            :unit="unit"
            :page="hisQuery.page"
            :limit="hisQuery.limit"
          />
        </div>
        <div
          style="
            flex: 0 0 400px;
            width: 0px;
            height: 800px;
            flex-direction: column;
          "
          class="df"
        >
          <div style="text-align: left; width: 100%; margin-bottom: 20px">
            <el-radio-group v-model="radioValue" size="mini" @input="tagChange">
              <el-radio-button
                v-for="tag in tagList"
                :label="tag.label"
                :key="tag.label"
                >{{ tag.label }}</el-radio-button
              >
            </el-radio-group>
          </div>
          <div
            style="
              flex: 1;
              height: 0;
              background-color: #f8f8f8;
              border-radius: 20px;
            "
          >
            <div style="height: 100%; width: 100%">
              <div
                style="height: 100%"
                class="df aic jcc"
                v-if="!hisListData.length"
              >
                <el-empty description="暂无记录"></el-empty>
              </div>
              <div class="modal-body" v-if="hisListData.length">
                <div
                  :class="{
                    card: true,
                    selected: hItem.id == checkedHisListId,
                  }"
                  v-for="hItem in hisListData"
                  :key="hItem.id"
                  @click="gethisDetail(hItem)"
                >
                  <div class="data-section">
                    <div class="data-item">
                      <div class="data-label">
                        {{
                          {
                            task_haccp_sensor: "工序",
                            task_sw_sensor: "名称",
                            fullChainTrace: "商品编码",
                            plantingFarmRecord: "种养名称",
                          }[hisListQuery.tag]
                        }}
                      </div>
                      <div class="data-value">
                        {{
                          hItem[
                            {
                              task_haccp_sensor: "templateName",
                              task_sw_sensor: "question",
                              fullChainTrace: "gtin",
                              plantingFarmRecord: "plantingName",
                            }[hisListQuery.tag]
                          ]
                        }}
                      </div>
                    </div>
                    <div class="data-item">
                      <div class="data-label">
                        {{
                          {
                            task_haccp_sensor: "批次",
                            task_sw_sensor: "批次",
                            fullChainTrace: "批次",
                            plantingFarmRecord: "农事农活",
                          }[hisListQuery.tag]
                        }}
                      </div>
                      <div class="data-value">
                        {{
                          hItem[
                            {
                              task_haccp_sensor: "recordName",
                              task_sw_sensor: "batch",
                              fullChainTrace: "batchNumber",
                              plantingFarmRecord: "name",
                            }[hisListQuery.tag]
                          ]
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="time-info">
                    <span class="time-label">
                      {{ hItem.startTime }}
                      <span style="color: #464547; margin: 0 10px">至</span>
                      {{ hItem.endTime }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="width: 100%; margin-top: 10px" class="df aic jcc">
            <el-pagination
              background
              @current-change="hisListChange"
              :current-page="hisListQuery.page"
              :page-size="hisListQuery.limit"
              layout="total, prev, pager, next"
              :total="hisListTotal"
            ></el-pagination>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <el-table
        :data="paginatedData"
        border
        fit
        height="800"
        v-loading="sensorLoading1"
      >
        <el-table-column
          align="center"
          property="data"
          label="值"
        ></el-table-column>
        <el-table-column
          align="center"
          property="time"
          label="时间"
        ></el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="hisQuery.page"
          :page-size="hisQuery.limit"
          layout="total, prev, pager, next"
          :total="totalPages"
        ></el-pagination>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { pickerOptions } from "./optionData";
import { local } from "../../util/util";
import api from "../../util/extra-api";
import SensorCharts from "./index.vue";

export default {
  name: "SensorPopup",
  components: {
    SensorCharts,
  },
  props: {
    // 标题
    title: {
      type: String,
      default: "传感器数据",
    },
    // 传感器ID
    sensorId: {
      type: [String, Number],
      required: true,
    },
    // 是否显示弹窗
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      hisListDetailTotal: 0,
      hisListDetail: [],
      checkedHisListId: null,
      hisListTotal: 0,
      radioValue: "食品加工",
      hisListData: [],
      hisListQuery: {
        deviceId: null,
        page: 1,
        limit: 15,
        tag: "task_haccp_sensor",
      },
      tagList: [
        {
          label: "食品加工",
          value: "task_haccp_sensor",
        },
        {
          label: "日常食安",
          value: "task_sw_sensor",
        },
        {
          label: "全链追溯",
          value: "fullChainTrace",
        },
        {
          label: "种养生产",
          value: "plantingFarmRecord",
        },
      ],
      sensorLoading1: false,
      gridTableData: [],
      showCharts: true,
      dateRange: "",
      hisQuery: {
        id: null,
        page: 1,
        companyId: null,
        limit: 20,
        startTime: "",
        endTime: "",
      },
      gridData: [],
      unit: "",
      pickerOptions,
    };
  },
  computed: {
    totalPages() {
      if (this.checkedHisListId) {
        return this.hisListDetailTotal;
      } else {
        return this.gridTableData.length;
      }
    },
    paginatedData() {
      if (this.checkedHisListId) {
        const start = (this.hisQuery.page - 1) * this.hisQuery.limit;
        const end = start + this.hisQuery.limit;
        return this.hisListDetail.slice(start, end);
      } else {
        const start = (this.hisQuery.page - 1) * this.hisQuery.limit;
        const end = start + this.hisQuery.limit;
        return this.gridTableData.slice(start, end);
      }
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.dialogVisible = newVal;
        if (newVal) {
          this.initDialog();
        }
      },
    },
    dialogVisible(newVal) {
      this.$emit("update:visible", newVal);
      if (!newVal) {
        this.resetData();
      }
    },
    sensorId: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.dialogVisible) {
          this.initDialog();
        }
      },
    },
  },
  methods: {
    // 初始化弹窗数据
    initDialog() {
      if (!this.sensorId) {
        console.error("Sensor ID is required");
        return;
      }

      this.showCharts = true;
      this.radioValue = "食品加工";
      this.hisQuery.id = this.sensorId;
      this.dateRange = [];
      this.hisQuery.page = 1;

      this.hisListQuery.deviceId = this.sensorId;
      this.hisListQuery.page = 1;
      this.hisListData = [];
      this.hisListTotal = 0;
      this.hisListQuery.tag = "task_haccp_sensor";
      this.checkedHisListId = null;

      this.hisQuery.companyId = local.get("company_id");
      this.loadSensorData();
      this.getDeviceHistoryList();
    },

    // 重置数据
    resetData() {
      this.hisQuery.startTime = "";
      this.hisQuery.endTime = "";
      this.hisQuery.page = 1;
      this.dateRange = [];
      this.checkedHisListId = null;
      this.gridData = [];
      this.gridTableData = [];
      this.hisListData = [];
    },

    // 关闭弹窗
    handleClose() {
      this.$emit("close");
    },

    // 加载传感器数据
    loadSensorData() {
      this.sensorLoading1 = true;
      api
        .get("/v1/wx/device/sensorHisData", this.hisQuery)
        .then((response) => {
          const data = response.data;
          if (this.hisQuery.page === 1) {
            this.gridData = [];
          }

          this.$emit("titleChange", data.name);
          this.gridTableData = data.data.map((m) => {
            return {
              data: m.value + m.unit,
              time: m.timeDate,
            };
          });
          this.gridData = this.gridData.concat(
            data.data.map((m) => {
              return {
                data: m.value,
                time: m.timeDate,
              };
            })
          );

          if (data.data && data.data.length > 0) {
            this.unit = data.data[0].unit;
          } else {
            this.unit = "";
          }
          this.sensorLoading1 = false;
        })
        .catch((error) => {
          console.error("Failed to load sensor data:", error);
          this.sensorLoading1 = false;
        });
    },

    // 获取历史详情
    gethisDetail(data) {
      this.checkedHisListId = data.id;
      api
        .get("/v1/wx/device/deviceHistoryChart", {
          id: data.id,
          tag: this.hisListQuery.tag,
        })
        .then((res) => {
          if (res.code === 200) {
            this.hisQuery.page = 1;
            this.hisListDetailTotal = res.data.length;
            this.hisListDetail = res.data.map((m) => {
              return {
                data: m.value,
                time: m.time,
              };
            });
          }
        });
    },

    // 标签切换
    tagChange(value) {
      this.hisListData = [];
      this.hisQuery.page = 1;
      this.hisListQuery.tag = this.tagList.filter(
        (v) => v.label === value
      )[0].value;
      this.hisListQuery.page = 1;
      this.getDeviceHistoryList();
    },

    // 历史列表分页
    hisListChange(page) {
      this.hisListQuery.page = page;
      this.getDeviceHistoryList();
    },

    // 加载更多数据
    handleLoadMore() {
      this.handleCurrentChange(this.hisQuery.page + 1);
    },

    // 搜索
    onSearch(value) {
      if (!value) {
        this.hisQuery.startTime = "";
        this.hisQuery.endTime = "";
      } else {
        this.hisQuery.startTime = this.dateRange[0];
        this.hisQuery.endTime = this.dateRange[1];
      }
      this.sensorLoading1 = true;
      this.hisQuery.page = 1;
      this.loadSensorData();
    },

    // 切换图表/表格显示
    changeShowCharts() {
      this.showCharts = !this.showCharts;
    },

    // 表格分页
    handleCurrentChange(val) {
      this.hisQuery.page = val;
      this.sensorLoading1 = true;
      setTimeout(() => {
        this.sensorLoading1 = false;
      }, 1000);
    },

    // 获取设备历史列表
    getDeviceHistoryList() {
      api
        .get("/v1/wx/device/deviceHistoryList", this.hisListQuery)
        .then((res) => {
          if (res.code === 200) {
            this.hisListData = res.data;
            this.hisListTotal = res.total;
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.charts-dialog {
  /deep/ .el-dialog {
    width: 1240px !important;
  }
}

.df {
  display: flex;
}

.aic {
  align-items: center;
}

.jcc {
  justify-content: center;
}

.modal-body {
  padding: 10px;
  overflow-y: auto;
  height: 100%;
  overflow-x: hidden;
}

.card {
  width: 100%;
  background: white;
  border-radius: 6px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
  padding: 16px;
  transition: all 0.2s ease;
  cursor: pointer;
  border: 1px solid #eaeaea;
  margin-bottom: 5px;
}

.card:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
  border-color: #d0d7de;
}

.data-section {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.data-item {
  flex: 1;
}

.data-label {
  font-size: 12px;
  color: #777;
  margin-bottom: 4px;
  font-weight: 500;
}

.data-value {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  line-height: 1.4;
  word-break: break-word;
}

.time-info {
  background-color: #f0f7ff;
  border-radius: 4px;
  padding: 10px 12px;
  display: flex;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  color: #2c3e50;
  border-left: 3px solid #4a90e2;
}

.time-label {
  color: #4a90e2;
}

.card.selected {
  border: 2px solid #4a90e2;
  background-color: #f0f7ff;
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.2);
  transform: translateY(-1px);
}

.card.selected .time-info {
  background-color: #fff;
}

.pagination-container {
  margin-top: 20px;
  text-align: center;
}

.modal-body::-webkit-scrollbar {
  width: 10px;
}

.modal-body::-webkit-scrollbar-track {
  background: #f0f7ff;
  border-radius: 5px;
  border-left: 1px solid #e1e8f0;
}

.modal-body::-webkit-scrollbar-thumb {
  background: #4a90e2;
  border-radius: 5px;
  border: 2px solid #f0f7ff;
  box-shadow: 0 2px 4px rgba(74, 144, 226, 0.2);
}

.modal-body::-webkit-scrollbar-thumb:hover {
  background: #357abd;
  box-shadow: 0 4px 8px rgba(74, 144, 226, 0.3);
}
</style>